<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{ $t('FILES.ITEMS') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="dialogCreate = true">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('FILES.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <documents
        :documents="documents"
        @edit="editDocument"
        @delete="deleteDocument"
      ></documents>
    </v-sheet>

    <v-dialog
      v-if="dialogCreate"
      v-model="dialogCreate"
      persistent
      max-width="500px"
    >
      <create
        :person="person"
        @cancel="dialogCreate = !dialogCreate"
        @success="createdDocument"
      ></create>
    </v-dialog>

    <v-dialog
      v-if="dialogEdit"
      v-model="dialogEdit"
      persistent
      max-width="400px"
    >
      <edit
        :person="person"
        :document="document"
        @cancel="dialogEdit = !dialogEdit"
        @success="editedDocument"
      ></edit>
    </v-dialog>

    <v-dialog
      v-if="dialogDelete"
      v-model="dialogDelete"
      persistent
      max-width="500px"
    >
      <delete
        :id="document.id"
        :person="person"
        @cancel="dialogDelete = !dialogDelete"
        @success="deletedDocument"
      ></delete>
    </v-dialog>
  </div>
</template>

<script>
import Documents from '@/components/documents/Documents';
import Create from '@/components/documents/Create';
import Edit from '@/components/documents/Edit';
import Delete from '@/components/documents/Delete';

export default {
  name: 'DocumentLayout',

  components: {
    Documents,
    Create,
    Edit,
    Delete
  },

  props: {
    person: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    dialogCreate: false,
    dialogEdit: false,
    dialogDelete: false,

    documents: [],
    document: {}
  }),

  created() {
    // this.refreshDocuments()
    if (this.person) this.documents = this.person.documents;
    else this.refreshDocuments();
  },

  methods: {
    createdDocument() {
      this.dialogCreate = !this.dialogCreate;
      this.refreshDocuments();
    },

    deleteDocument(document) {
      this.document = document;
      this.dialogDelete = !this.dialogDelete;
    },

    deletedDocument() {
      this.dialogDelete = !this.dialogDelete;
      this.refreshDocuments();
    },

    editDocument(document) {
      this.document = document;
      this.dialogEdit = !this.dialogEdit;
    },

    editedDocument() {
      this.dialogEdit = !this.dialogEdit;
      this.refreshDocuments();
    },

    refreshDocuments() {
      if (this.person) {
        this.$store
          .dispatch('document/retrieveDocumentsForPerson', this.person.id)
          .then(({ data }) => {
            this.documents = data.data;
            // TODO this.documents = this.person.uploads
          });
      } else {
        this.$store.dispatch('document/retrieveDocuments').then(({ data }) => {
          this.$store.commit('document/retrievedDocuments', data.data);
          this.documents = this.$store.state.document.documents;
        });
      }
    }
  }
};
</script>
